export default __webpack_public_path__ + "static/media/pdl-placeholder.674505f8.png";